import { Action } from '@reduxjs/toolkit';

/**
 * Hidden flag for Actions with transferables.
 */
export const TRANSFERABLE_FLAG = Symbol('@@workeredux/transferable');

export type ActionWithTransferable<T extends string> = Action<T> & {
  readonly [TRANSFERABLE_FLAG]: Transferable[];
};

/**
 * Checks if the Action has any Transferable object(s).
 */
export const hasTransferables = <T extends string>(
  action: Action<T>
): action is ActionWithTransferable<T> => TRANSFERABLE_FLAG in action;

/**
 * Sets the Transferable object(s) and returns a new Action.
 */
export const setTransferables = <T extends string>(
  action: Action<T>,
  transfer: ReadonlyArray<Transferable>
) => Object.assign({}, action, { [TRANSFERABLE_FLAG]: transfer });

/**
 * Gets the Transferable object(s) from the Action.
 */
export const getTransferables = <T extends string>(
  action: Action<T>
): ReadonlyArray<Transferable> | undefined =>
  hasTransferables(action) ? action[TRANSFERABLE_FLAG] : undefined;
